<template>
  <div>
    <PageHeaderBanner>
      <template #title>会員一覧</template>
      <template #button-area>
        <q-btn
          color="primary"
          icon="mdi-plus"
          label="新規管理者登録"
          :to="{ name: 'adminRegist', params: { login: '1' } }"
        />
      </template>
    </PageHeaderBanner>
    <div class="cmi00300-list-container q-mb-lg">
      <!-- 未確認会員一覧 -->
      <q-list bordered class="rounded-borders unconfirmed-memberlist">
        <q-expansion-item v-model="panel" expand-icon-toggle expand-separator>
          <template #header>
            <q-item-section>
              <div class="row items-center">
                <div class="row q-gutter-lg items-center" style="width: 210px; margin-right: 20px">
                  <div><span class="title">未確認</span></div>
                  <label class="count">{{ MKaiinNotConfirmedRows.length }}</label>
                </div>
              </div>
            </q-item-section>
            <q-space />
          </template>
          <div
            :class="
              'chem-table-area btn-exist ' +
              (MKaiinNotConfirmedRows.length === 0 ? 'table-nodata' : '')
            "
          >
            <q-table
              class="my-sticky-header-column-member-table"
              :columns="NotConfirmedList"
              :rows="MKaiinNotConfirmedRows"
              row-key="index"
              flat
              dense
              separator="cell"
              :hide-no-data="hideNoDataFlg"
              no-data-label="データがありません。"
              :rows-per-page-options="[10, 20, 50, 0]"
              rows-per-page-label="件表示"
              rows-per-page="20"
              :pagination-label="
                (firstRowIndex, endRowIndex, totalRowsNumber) => {
                  return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
                }
              "
            >
              <template #no-data="{ message }">
                <div class="full-width row q-gutter-sm">
                  <q-icon size="24px" name="mdi-alert-circle-outline" />
                  <span class="q-pt-xs">{{ message }}</span>
                </div>
              </template>
              <!-- 編集削除Header -->
              <template #header-cell-editDelete>
                <q-th class="table-btn-area approvalbtn-exist"></q-th>
              </template>

              <!-- 編集、削除Body -->
              <template #body-cell-editDelete="cell">
                <q-td v-if="!hideNoDataFlg" class="table-btn-area approvalbtn-exist">
                  <div class="flex">
                    <q-btn
                      color="primary"
                      icon="mdi-account-supervisor"
                      label="承認設定"
                      style="width: 120px"
                      @click.stop="approvalSetting(cell.row.user_id)"
                    />
                    <q-btn
                      label="削除"
                      icon="mdi-close"
                      class="deletebtn"
                      color="primary"
                      outline
                      style="color: var(--q-delete)"
                      @click="deleteNotConfirmed(cell.row.user_id)"
                    />
                  </div>
                </q-td>
              </template>

              <template #body-cell="body">
                <q-td v-if="!hideNoDataFlg" :props="body">{{ body.value }}</q-td>
              </template>
            </q-table>
          </div>
        </q-expansion-item>
      </q-list>
      <!-- 確認済み会員一覧 -->
      <q-list class="rounded-borders confirmed-memberlist">
        <q-item-section class="q-mb-sm">
          <div class="row items-center">
            <div class="row q-gutter-lg items-center" style="width: 210px; margin-right: 20px">
              <div><span class="title">確認済み</span></div>
              <label class="count">{{
                inputData.excelFlag
                  ? MKaiinConfirmedRows.length
                  : MKaiinConfirmedRowsApproval.length
              }}</label>
            </div>

            <div class="row justify-between items-center" style="width: calc(100% - 206px)">
              <q-toggle
                v-model="inputData.excelFlag"
                hide-details
                :label="`未承認表示`"
                :true-val="true"
                :false-val="false"
              />
              <div class="row justify-end">
                <div style="width: 140px">
                  <q-btn
                    color="primary"
                    :class="
                      'export-btn excel-exportbtn ' +
                      ((inputData.excelFlag
                        ? MKaiinConfirmedRows.length
                        : MKaiinConfirmedRowsApproval.length) === 0
                        ? 'cmi00300-disabled-btn'
                        : '')
                    "
                    :outline="
                      (inputData.excelFlag
                        ? MKaiinConfirmedRows.length
                        : MKaiinConfirmedRowsApproval.length) !== 0
                        ? true
                        : false
                    "
                    icon="mdi-download"
                    no-caps
                    :disable="
                      (inputData.excelFlag
                        ? MKaiinConfirmedRows.length
                        : MKaiinConfirmedRowsApproval.length) === 0
                    "
                    @click="excelFlag = true"
                    >Excel出力</q-btn
                  >
                  <q-tooltip
                    v-if="
                      inputData.excelFlag
                        ? MKaiinConfirmedRows.length === 0
                        : MKaiinConfirmedRowsApproval.length === 0
                    "
                    anchor="top right"
                    :offset="[-70, 8]"
                    self="bottom middle"
                  >
                    <strong>検索結果が存在しません。</strong>
                  </q-tooltip>
                </div>
              </div>
            </div>
          </div>
        </q-item-section>

        <!-- 検索エリア -->
        <q-form novalidate @submit="getSearchMemberInfo">
          <div class="freeword-search-area row items-center">
            <div class="col-5">
              <q-input
                id="searchWord"
                ref="searchWord"
                v-model="inputData.searchWord"
                name="searchWord"
                outlined
                dense
                maxlength="100"
                style="background: var(--q-white)"
                class="q-mr-xs input-area"
                @keydown.enter.prevent
              />
            </div>
            <div class="col">
              <q-btn
                color="primary"
                class="q-mr-xs"
                icon="mdi-magnify"
                label="検索"
                type="search"
              />
              <q-btn
                style="color: var(--q-delete)"
                outline
                icon="mdi-eraser"
                label="クリア"
                @click="resetForm"
              />
            </div>
          </div>
        </q-form>

        <div
          :class="
            'chem-table-area confirmed-table-area btn-exist ' +
            (inputData.excelFlag
              ? MKaiinConfirmedRows.length === 0
                ? 'table-nodata'
                : ''
              : MKaiinConfirmedRowsApproval.length === 0
              ? 'table-nodata'
              : '')
          "
        >
          <q-table
            class="my-sticky-header-column-member-table justify-between"
            :columns="columns"
            :rows="inputData.excelFlag ? MKaiinConfirmedRows : MKaiinConfirmedRowsApproval"
            row-key="index"
            flat
            dense
            separator="cell"
            :hide-no-data="hideNoDataFlg"
            no-data-label="データがありません。"
            :rows-per-page-options="[10, 20, 50, 0]"
            rows-per-page-label="件表示"
            rows-per-page="20"
            :pagination-label="
              (firstRowIndex, endRowIndex, totalRowsNumber) => {
                return `${totalRowsNumber} 件中 ${firstRowIndex}～${endRowIndex} 件表示`;
              }
            "
          >
            <template #no-data="{ message }">
              <div class="full-width row q-gutter-sm">
                <q-icon size="24px" name="mdi-alert-circle-outline" />
                <span class="q-pt-xs">{{ message }}</span>
              </div>
            </template>
            <!-- 編集削除Header -->
            <template #header-cell-editDelete>
              <q-th class="table-btn-area approvalbtn-exist"></q-th>
            </template>

            <!-- 編集、削除Body -->
            <template #body-cell-editDelete="body">
              <q-td v-if="!hideNoDataFlg" class="table-btn-area approvalbtn-exist">
                <div class="flex">
                  <div>
                    <q-btn
                      icon="mdi-account-supervisor"
                      color="primary"
                      style="width: 120px"
                      :disabled="body.row.auth_level === 'ADMIN'"
                      @click="approvalSetting(body.row.user_id)"
                    >
                      承認設定
                    </q-btn>
                    <q-tooltip
                      v-if="body.row.auth_level === 'ADMIN'"
                      anchor="top left"
                      :offset="[-70, 4]"
                      self="bottom middle"
                    >
                      <strong>管理者アカウントの情報は変更できません。</strong>
                    </q-tooltip>
                  </div>
                  <div>
                    <q-btn
                      label="削除"
                      icon="mdi-close"
                      class="deletebtn"
                      color="primary"
                      outline
                      style="color: var(--q-delete)"
                      @click="deleteConfirmed(body.row.user_id)"
                    />
                  </div>
                </div>
              </q-td>
            </template>
            <template #body-cell="cell">
              <q-td v-if="!hideNoDataFlg" :props="cell">{{ cell.value }}</q-td>
            </template>
          </q-table>
        </div>
      </q-list>
      <!-- 削除確認(未確認一覧)ダイアログ -->
      <AlertDialog
        :display="deleteNotConfirmedFlag"
        title="削除確認"
        level="information"
        :text="['会員登録せずに削除します。', 'よろしいですか？']"
        @confirm="deleteMember(inputData.userIdInfo)"
        @close="deleteNotConfirmedFlag = false"
      />
      <!-- 削除確認(確認済一覧)ダイアログ -->
      <AlertDialog
        :display="deleteConfirmedFlag"
        title="削除確認"
        level="information"
        :text="['会員情報を削除します。', 'よろしいですか？']"
        @confirm="deleteMember(inputData.userIdInfo)"
        @close="deleteConfirmedFlag = false"
      />
      <!-- 削除完了ダイアログ -->
      <AlertDialog
        :display="deleteConpFlag"
        level="information"
        confirmation
        title="会員削除完了"
        :text="['会員情報を削除しました。']"
        @complete="(deleteConpFlag = false), getMembersInfo()"
      />
      <!-- Excel出力確認ダイアログ -->
      <AlertDialog
        :display="excelFlag"
        title="Excel出力確認"
        level="information"
        :text="['会員情報のExcelファイルを出力します。', 'よろしいですか？']"
        @confirm="(excelFlag = false), downloadExcel()"
        @close="excelFlag = false"
      />
      <!-- Excel出力完了ダイアログ -->
      <AlertDialog
        :display="excelConpFlag"
        level="information"
        confirmation
        title="Excel出力完了"
        :text="['会員情報のExcelファイルを出力しました。']"
        @complete="excelConpFlag = false"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Loading } from 'quasar';
import axios from 'axios';
import saveAs from 'file-saver';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import base64toBlob from '../../common/utils/fileUtils';
import ResultStatusCode from '../../common/code/ResultStatusCode';

const router = useRouter();

// 会員情報(未確認)
interface MKaiinNotConfirmed {
  user_id: string;
  user_name_sei: string;
  user_name_mei: string;
  mail_address: string;
  work_school_name: string;
  create_timestamp: string;
}
// 会員情報(確認済)
interface MKaiinConfirmed {
  user_id: string;
  user_name_sei: string;
  user_name_mei: string;
  auth_level: string;
  mail_address: string;
  work_school_name: string;
  customer_cd: string;
  approval_stat: string;
  create_timestamp: string;
  update_timestamp: string;
}

// 会員情報(未確認)
const MKaiinNotConfirmedRows = ref([
  {
    user_id: '',
    create_timestamp: '',
    work_school_name: '',
    user_name_sei: '',
    user_name_mei: '',
    mail_address: '',
  },
]);
// 会員情報(確認済)
const MKaiinConfirmedRows = ref([
  {
    user_id: '',
    user_name_sei: '',
    user_name_mei: '',
    auth_level: '',
    mail_address: '',
    work_school_name: '',
    customer_cd: '',
    approval_stat: '',
    create_timestamp: '',
    update_timestamp: '',
  },
]);

// 会員情報(確認済承認済み)
const MKaiinConfirmedRowsApproval = ref([
  {
    user_id: '',
    user_name_sei: '',
    user_name_mei: '',
    auth_level: '',
    mail_address: '',
    work_school_name: '',
    customer_cd: '',
    approval_stat: '',
    create_timestamp: '',
    update_timestamp: '',
  },
]);

// user_name_seiとuser_name_meiの間に入れる空白
const blank = '　';
// 未確認会員リスト
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NotConfirmedList: Array<any> = [
  {
    name: 'editDelete',
    field: (row: MKaiinNotConfirmed) => row.user_name_sei + blank + row.user_name_mei,
  },
  {
    name: 'create_timestamp',
    label: '登録日時',
    align: 'left',
    field: (row: MKaiinNotConfirmed) =>
      row.create_timestamp.substring(0, 16).replace('-', '/').replace('-', '/'),
    sortable: true,
    style: 'width: 150px',
  },
  {
    name: 'work_school_name',
    label: '勤務先 / 学校名',
    align: 'left',
    field: (row: MKaiinNotConfirmed) => row.work_school_name,
    sortable: true,
  },
  {
    name: 'user_name_sei + user_name_mei',
    label: '氏名',
    align: 'left',
    field: (row: MKaiinNotConfirmed) => row.user_name_sei + blank + row.user_name_mei,
    sortable: true,
  },
  {
    name: 'mail_address',
    label: '会員ID（メールアドレス）',
    align: 'left',
    field: (row: MKaiinNotConfirmed) => row.mail_address,
    sortable: true,
  },
];

// 確認済み会員リスト
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const columns: Array<any> = [
  {
    name: 'editDelete',
    field: (row: MKaiinConfirmed) => row.user_name_sei + blank + row.user_name_mei,
  },
  {
    name: 'approval_stat',
    key: 'approval_stat',
    label: '承認状況',
    align: 'left',
    field: (row: MKaiinConfirmed) => (row.approval_stat === '0' ? '未承認' : '承認済み'),
    style: 'width: 100px',
    sortable: true,
  },
  {
    name: 'mail_address',
    label: '会員ID（メールアドレス）',
    align: 'left',
    field: (row: MKaiinConfirmed) => row.mail_address,
    sortable: true,
  },
  {
    name: 'name',
    label: '氏名',
    align: 'left',
    field: (row: MKaiinConfirmed) => row.user_name_sei + blank + row.user_name_mei,
    sortable: true,
  },
  {
    name: 'authrize',
    label: 'ユーザー権限',
    align: 'left',
    field: (row: MKaiinConfirmed) => (row.auth_level === 'MEMBER' ? '一般ユーザー' : '管理者'),
    sortable: true,
  },
  {
    name: 'customer_code',
    label: '得意先コード',
    align: 'left',
    field: (row: MKaiinConfirmed) => row.customer_cd,
    sortable: true,
  },
  {
    name: 'business_school',
    label: '勤務先 / 学校名',
    align: 'left',
    field: (row: MKaiinConfirmed) => row.work_school_name,
    sortable: true,
  },
  {
    name: 'regist_date',
    label: '登録日時',
    align: 'left',
    field: (row: MKaiinConfirmed) =>
      row.create_timestamp.substring(0, 16).replace('-', '/').replace('-', '/'),
    style: 'width: 150px',
    sortable: true,
  },
  {
    name: 'updated_date',
    label: '更新日時',
    align: 'left',
    field: (row: MKaiinConfirmed) =>
      row.update_timestamp === null
        ? ''
        : row.update_timestamp.substring(0, 16).replace('-', '/').replace('-', '/'),
    style: 'width: 150px',
    sortable: true,
  },
];
// 入力値
const inputData = reactive({
  searchWord: '',
  userIdInfo: '',
  excelFlag: true,
});
// 会員削除確認ダイアログフラグ
const deleteNotConfirmedFlag = ref(false);
// 会員削除確認ダイアログフラグ
const deleteConfirmedFlag = ref(false);
// 会員削除ダイアログフラグ
const deleteConpFlag = ref(false);
// Excelダイアログフラグ
const excelFlag = ref(false);
// Excelダウンロード完了ダイアログフラグ
const excelConpFlag = ref(false);
// 初期表示読み込み時「データがありません」を非表示にするためのフラグ(falseで表示)
const hideNoDataFlg = ref(true);

/**
 * 会員一覧取得処理
 */
const getMembersInfo = async () => {
  // Loading Start
  Loading.show();
  axios
    .post('/cmi003001/members')
    .then((res) => {
      const { common, mkaiinNotConfirmed, mkaiinConfirmed, mkaiinConfirmedApproved } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          MKaiinNotConfirmedRows.value = mkaiinNotConfirmed;
          MKaiinConfirmedRows.value = mkaiinConfirmed;
          MKaiinConfirmedRowsApproval.value = mkaiinConfirmedApproved;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
      hideNoDataFlg.value = false;
    });
};

/**
 * 会員検索処理
 */
const getSearchMemberInfo = async () => {
  // Loading Start
  Loading.show();
  // 検索データ作成
  const formData = new FormData();
  formData.append('searchWord', inputData.searchWord);
  axios
    .post('/cmi003001/members/search', formData)
    .then((res) => {
      const { common, mkaiinConfirmed, mkaiinConfirmedApproved } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          MKaiinConfirmedRows.value = mkaiinConfirmed;
          MKaiinConfirmedRowsApproval.value = mkaiinConfirmedApproved;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};
/**
 * 検索条件のリセット
 *
 */
const resetForm = async () => {
  inputData.searchWord = '';
  getMembersInfo();
};

/**
 * Excel出力処理
 */
const downloadExcel = async () => {
  // Loading Start
  Loading.show();
  // 検索データ作成
  const formData = new FormData();
  formData.append('searchWord', inputData.searchWord);
  if (inputData.excelFlag) {
    formData.append('selectFlag', '0');
  } else {
    formData.append('selectFlag', '1');
  }

  // Excel出力
  await axios
    .post('/cmi003001/members/excelOutput', formData)
    .then((res) => {
      const { common, body, file_name } = res.data;
      const blob = new Blob([
        base64toBlob(body, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'),
      ]);
      saveAs(blob, file_name);
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          excelConpFlag.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * 会員削除確認処理（未確認一覧）
 *
 */
const deleteNotConfirmed = async (userId: string) => {
  inputData.userIdInfo = userId;
  deleteNotConfirmedFlag.value = true;
};
/**
 * 会員削除確認処理（確認済み一覧）
 *
 */
const deleteConfirmed = async (userId: string) => {
  inputData.userIdInfo = userId;
  deleteConfirmedFlag.value = true;
};

/**
 * 会員削除処理
 *
 */
const deleteMember = async (userId: string) => {
  // Loading Start
  Loading.show();
  // データ作成
  const formData = new FormData();
  formData.append('user_id', userId);

  await axios
    .post('/cmi003001/member/delete', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログ表示
          deleteNotConfirmedFlag.value = false;
          deleteConfirmedFlag.value = false;
          deleteConpFlag.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};
const panel = ref(true);

// 承認設定画面への遷移
const approvalSetting = (userId: string) => {
  router.push({ name: 'approvalSetting', params: { userId } });
};

// 初期表示
getMembersInfo();
</script>
<style scoped>
.cmi00300-list-container {
  width: 80%;
  margin: 0 auto;
}

.chem-table-area.btn-exist .table-btn-area.approvalbtn-exist {
  padding-left: 0;
  padding-right: 0;
}
.chem-table-area.btn-exist .table-btn-area.approvalbtn-exist .flex {
  width: 230px;
}

.unconfirmed-memberlist .title {
  font-size: 1.1rem;
  font-weight: 600;
  border-bottom: 1px solid var(--q-dark);
}
.unconfirmed-memberlist label {
  color: var(--q-theme-white);
  background: var(--q-unconfirmed);
  padding: 0.2rem 1.2rem;
  font-weight: 600;
  border-radius: 15px;
  font-size: 1.2rem;
}

.confirmed-table-area {
  margin-top: 80px;
}
.confirmed-memberlist .chem-table-area.btn-exist .table-btn-area.approvalbtn-exist {
  padding-left: 0;
  padding-right: 0;
}

.chem-table-area.btn-exist .table-btn-area.approvalbtn-exist .flex {
  width: 230px;
}
.confirmed-memberlist {
  margin-top: 10px;
  border: 1px solid var(--q-dark);
  border-radius: 10px;
  border-radius: 4px;
}
.confirmed-memberlist .title {
  font-size: 1.1rem;
  font-weight: 600;
  border-bottom: 1px solid var(--q-dark);
}
.confirmed-memberlist .count {
  color: var(--v-white);
  background: var(--q-approval);
  padding: 0.2rem 1.2rem;
  font-weight: 600;
  border-radius: 15px;
  font-size: 1.2rem;
}
.confirmed-memberlist .freeword-search-area {
  margin-bottom: -34px;
}
.cmi00300-list-container .chem-table-area.table-nodata {
  margin-top: 45px;
}
</style>
<style>
.unconfirmed-memberlist .q-card__section {
  padding: 0;
}

.unconfirmed-memberlist.q-list {
  padding: 10px 16px 20px;
  border: 1px solid var(--q-dark);
}

.confirmed-memberlist.q-list {
  padding: 10px 16px 20px;
  border: 1px solid var(--q-dark);
}

.cmi00300-list-container .q-item {
  padding: 0;
}

.cmi00300-list-container .chem-table-area {
  padding-bottom: 0;
}
.cmi00300-list-container .confirmed-memberlist .q-field--dense .q-field__control {
  height: 36px;
}
.cmi00300-list-container .cmi00300-disabled-btn {
  background-color: var(--q-opacityDisable) !important;
  color: #fff !important;
}

.cmi00300-list-container .chem-table-area .q-table__container.column {
  margin-top: 30px;
}
</style>

<style lang="sass">
.my-sticky-header-column-member-table
  /* height or max-height is important */
  max-height: 590px

  /* specifying max-width so the example can
    highlight the sticky column on any browser window */

  td:first-child
    /* bg color is important for td; just specify one */
    background-color: #fff

  tr th
    position: sticky
    /* higher than z-index for td below */
    z-index: 2
    /* bg color is important; just specify one */
    background: #fff

  /* this will be the loading indicator */
  thead tr:last-child th
    /* height of all previous header rows */
    top: 48px
    /* highest z-index */
    z-index: 3
  thead tr:first-child th
    top: 0
    z-index: 1
  tr:first-child th:first-child
    /* highest z-index */
    z-index: 3

  td:first-child
    z-index: 1

  td:first-child, th:first-child
    position: sticky
    left: 0

  /* prevent scrolling behind sticky top row on focus */
  tbody
    /* height of all previous header rows */
    scroll-margin-top: 48px
</style>
